import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.217 3.747a2.55 2.55 0 0 1 3.606 0l.429.43a2.55 2.55 0 0 1 0 3.606l-6.986 6.99a2.6 2.6 0 0 1-1.105.648l-3.543 1.013a.81.81 0 0 1-.836-.248c-.216-.188-.3-.507-.216-.804l1.013-3.543c.12-.418.344-.797.649-1.105zm2.374 1.202c-.302-.332-.84-.332-1.173 0l-1.03 1.03 1.632 1.634 1.031-1.063c.333-.3.333-.84 0-1.171zm-8.375 7.358-.595 2.072 2.072-.595a.83.83 0 0 0 .369-.216l4.757-4.754-1.633-1.633-4.754 4.757a.83.83 0 0 0-.216.369m-.131-7.177a.85.85 0 1 1 0 1.7H6.117c-.782 0-1.417.634-1.417 1.417v9.636c0 .783.635 1.417 1.417 1.417h9.636c.783 0 1.417-.634 1.417-1.417v-3.968c0-.471.379-.85.85-.85s.85.379.85.85v3.968A3.117 3.117 0 0 1 15.753 21H6.117A3.117 3.117 0 0 1 3 17.883V8.247A3.117 3.117 0 0 1 6.117 5.13z"
    }, null, -1)
  ]))]))
}
export default { render: render }